import { FC, useContext, useEffect } from 'react'
import { IonRouterContext } from '@ionic/react'

import { Context } from '@lib/store'
import { Routes } from '@/router/routes'

export const RedirectToLogin: FC = () => {
  const ionRouterContext = useContext(IonRouterContext)
  const { state } = useContext(Context)

  useEffect(() => {
    if (state.signInRedirectPath) {
      // eg for referral signups, signInRedirectPath is the profile page of the referring user
      ionRouterContext?.push(state.signInRedirectPath, 'root')
    } else {
      ionRouterContext?.push(Routes.FEED)
    }
  }, [ionRouterContext, state.signInRedirectPath])

  return null
}
